import { relationNodes, relationEdges } from '@/mocks/galData';

const edgeStyle: Record<string, { dot: string; text: string; ring: string }> = {
  romance: { dot: 'bg-primary-500', text: 'text-primary-700', ring: 'ring-primary-200' },
  friend: { dot: 'bg-secondary-400', text: 'text-secondary-700', ring: 'ring-secondary-200' },
  family: { dot: 'bg-accent-500', text: 'text-accent-700', ring: 'ring-accent-200' },
  rival: { dot: 'bg-foreground-600', text: 'text-foreground-700', ring: 'ring-foreground-200' },
};

const edgeLabel: Record<string, string> = {
  romance: '感情线',
  friend: '友情',
  family: '亲情/青梅',
  rival: '情愫纠葛',
};

export default function Relations() {
  return (
    <section id="relations" className="scroll-mt-24 bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-8 text-center">
          <span className="inline-block rounded-full bg-primary-100 px-4 py-1.5 text-sm text-primary-700">
            泡在我家的辣妹人物关系
          </span>
          <h2 className="mt-3 font-heading text-2xl text-foreground-950 md:text-4xl">
            人物关系图：谁和谁是什么关系
          </h2>
          <p className="mx-auto mt-3 max-w-2xl text-sm text-foreground-700 md:text-base">
            以男女主为轴心，把所有主要角色和他们的关系线一次理清。看这张图，泡在我家的辣妹人物关系就一目了然了。
          </p>
        </div>

        <div className="relative overflow-hidden rounded-3xl border border-background-200 bg-gradient-to-br from-primary-50 via-background-50 to-accent-50 p-6 md:p-10">
          {/* 关系图主体：网格排布角色节点 */}
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-5">
            {relationNodes.map((node) => {
              const isFemale = node.id === 'female-lead';
              const isMale = node.id === 'male-lead';
              return (
                <div
                  key={node.id}
                  className={`relative rounded-2xl border p-4 text-center transition-transform hover:-translate-y-1 ${
                    isFemale
                      ? 'border-primary-200 bg-primary-50 ring-2 ring-primary-200'
                      : isMale
                        ? 'border-accent-200 bg-accent-50 ring-2 ring-accent-200'
                        : 'border-background-200 bg-background-50'
                  }`}
                >
                  <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-primary-100 text-xl text-primary-600">
                    <i
                      className={
                        node.id === 'female-lead'
                          ? 'ri-women-line'
                          : node.id === 'male-lead'
                            ? 'ri-men-line'
                            : 'ri-user-smile-line'
                      }
                    ></i>
                  </div>
                  <h3 className="mt-3 font-heading text-lg text-foreground-950">
                    {node.name}
                  </h3>
                  <p className="mt-1 text-xs text-foreground-600">{node.role}</p>
                </div>
              );
            })}
          </div>

          {/* 关系图例与连线说明 */}
          <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-2">
            <div className="flex flex-wrap items-center gap-4">
              {Object.keys(edgeStyle).map((key) => (
                <span
                  key={key}
                  className="inline-flex items-center gap-2 text-sm text-foreground-700"
                >
                  <span className={`h-2.5 w-2.5 rounded-full ${edgeStyle[key].dot}`}></span>
                  {edgeLabel[key]}
                </span>
              ))}
            </div>
            <p className="text-sm text-foreground-600">
              主线以<span className="font-medium text-primary-700">感情线</span>
              为核心：铃音与遥因寄宿结缘，凛助攻、葵暗恋、优纪看戏，共同织成一张温馨又有趣的关系网。
            </p>
          </div>
        </div>

        {/* 关系列表 */}
        <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {relationEdges.map((edge) => (
            <div
              key={`${edge.from}-${edge.to}`}
              className={`rounded-2xl border border-background-200 bg-background-50 p-4 ring-1 ${edgeStyle[edge.type].ring}`}
            >
              <div className="flex items-center gap-2">
                <span className={`h-2 w-2 rounded-full ${edgeStyle[edge.type].dot}`}></span>
                <span className={`text-xs ${edgeStyle[edge.type].text}`}>
                  {edgeLabel[edge.type]}
                </span>
              </div>
              <div className="mt-3 flex items-center justify-between">
                <div className="text-center">
                  <div className="text-sm font-medium text-foreground-950">
                    {relationNodes.find((n) => n.id === edge.from)?.name}
                  </div>
                  <div className="text-xs text-foreground-600">
                    {relationNodes.find((n) => n.id === edge.from)?.role}
                  </div>
                </div>
                <div className="flex flex-1 items-center px-2">
                  <span className="h-px flex-1 border-t-2 border-dashed border-foreground-300"></span>
                  <span className="mx-1 whitespace-nowrap rounded-full bg-background-100 px-2 py-0.5 text-xs text-foreground-700">
                    {edge.label}
                  </span>
                  <span className="h-px flex-1 border-t-2 border-dashed border-foreground-300"></span>
                </div>
                <div className="text-center">
                  <div className="text-sm font-medium text-foreground-950">
                    {relationNodes.find((n) => n.id === edge.to)?.name}
                  </div>
                  <div className="text-xs text-foreground-600">
                    {relationNodes.find((n) => n.id === edge.to)?.role}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}